/* src/app/pages/site-in-maintenance/site-in-maintenance.component.less */
:host {
  display: block;
}
.site-container {
  background:
    linear-gradient(
      180deg,
      #007888 0%,
      #8CC7D3 59.13%,
      #FFFFFF 100%);
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.site-container .image-container {
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.site-container .image-container img {
  width: 90%;
}
.site-container .info {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.site-container .info h1 {
  font-weight: 600;
  font-size: 40px;
  text-align: center;
  color: #ffffff;
}
.site-container .info p {
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  color: #ffffff;
}
.site-container .info button {
  border-radius: 5px;
  padding: 15px;
  color: #ffffff;
  font-size: 20px;
  background-color: #007888;
  box-shadow: 0px 4px 4px 0px #00000040;
  border: none;
  margin-top: 5rem;
}
@media screen and (max-width: 820px) {
  .site-container {
    flex-direction: column;
  }
  .site-container .image-container {
    width: 80%;
    margin-top: 5rem;
  }
  .site-container .image-container img {
    width: 90%;
  }
  .site-container .info p {
    width: 80%;
  }
}
@media screen and (max-width: 540px) and (max-height: 720px) {
  .site-container .image-container img {
    width: 60%;
  }
}
@media screen and (max-width: 450px) {
  .site-container .info h1 {
    font-size: 22px;
  }
  .site-container .info p {
    font-size: 16px;
    width: 100%;
  }
  .site-container .info button {
    font-size: 16px;
  }
}
/*# sourceMappingURL=site-in-maintenance.component-E4QUST5Z.css.map */
